"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WriteOffProjectRequest = void 0;
var WriteOffProjectRequest = /** @class */ (function () {
    function WriteOffProjectRequest() {
    }
    return WriteOffProjectRequest;
}());
exports.WriteOffProjectRequest = WriteOffProjectRequest;
//# sourceMappingURL=writeOffProject.request.js.map